import { FC, useContext, useMemo } from 'react';
import { HomePageContext } from 'src/constructors/pageConstructors/HomePageConstructor';
import StoriesWidget from './StoriesWidget';

export type Props = {
  settings: any;
  type: string;
};

export const Stories: FC<Props> = ({ settings, type }) => {
  const homePageContext = useContext(HomePageContext);

  const storiesData = useMemo(() => {
    if (type === 'home') {
      return homePageContext?.pageFields?.storyGroup;
    }
    return null;
  }, [homePageContext, settings?.data?.pageContext]);

  return <StoriesWidget storiesData={storiesData} />;
};

export default Stories;
